import { render, staticRenderFns } from "./BaseFile.vue?vue&type=template&id=21871634&scoped=true&"
import script from "./BaseFile.vue?vue&type=script&lang=js&"
export * from "./BaseFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseFile.vue?vue&type=style&index=0&id=21871634&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21871634",
  null
  
)

export default component.exports